import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";
import CrmAiSearchModal, { CrmAiSearchFocus } from "./CrmAiSearchModal";
import "./CrmAiSearchModal.scss";

interface Props {
  boardId?: string;
  className?: string;
  focus?: CrmAiSearchFocus;
}

export default function CrmAiSearchTrigger({
  boardId,
  className,
  focus = "all",
}: Props) {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const titleId =
    focus === "contacts"
      ? "app.crmBusiness.aiSearch.contacts.title"
      : focus === "companies"
        ? "app.crmBusiness.aiSearch.companies.title"
        : "app.crmBusiness.aiSearch.title";
  const title = intl.formatMessage({ id: titleId });

  return (
    <>
      <button
        type="button"
        className={
          className ? `crm-ai-search-trigger ${className}` : "crm-ai-search-trigger"
        }
        title={title}
        aria-label={title}
        onClick={() => setOpen(true)}
      >
        <FontAwesomeIcon icon={["fas", "magic"]} />
      </button>
      <CrmAiSearchModal
        isOpen={open}
        boardId={boardId}
        focus={focus}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
